import { Injectable } from '@angular/core';
import { CanvasInputMode, CanvasInputModeService } from './canvas-input-mode.service';

@Injectable({ providedIn: 'root' })
export class TextModeHelperService {
    constructor(private inputMode: CanvasInputModeService) {}

    init(): void {
        this.bindMouseEvents();
    }

    private bindMouseEvents() {
        document.addEventListener('mousedown', this.handleMouseDown.bind(this));
        document.addEventListener('mousemove', this.handleMouseMove.bind(this));
        document.addEventListener('mouseup', this.handleMouseUp.bind(this));
    }

    private handleMouseDown(event: MouseEvent) {
        if (this.inputMode.getMode() === CanvasInputMode.TEXT_EDIT) {
            if ((event.target as any)?.tagName === 'text') {
                return;
            }
            this.inputMode.setMode(CanvasInputMode.SELECT);
        }
    }

    private handleMouseMove(event: MouseEvent) {}

    private async handleMouseUp(event: MouseEvent) {}
}
